import { Connector, Chain } from "wagmi";
// import Upbond from "@upbond/upbond-embed";
import Upbond from "@upbond/upbond-embed";
import { ethers } from "ethers";

export class UpbondConnector extends Connector {
  id = "upbond";
  name = "Upbond";
  ready = true;

  constructor(config) {
    super(config);
    this.chains = config.chains;
    this.options = config.options;
    this.upbond = new Upbond({});
    this.chain = 80001;
  }
  async connect() {
    try {
      console.log("Connecting...", this.upbond);
      if (!this.upbond.isInitialized) {
        await this.upbond.init({
          buildEnv: this.options.buildEnv,
          network: {
            host: "matic",
            chainId: 137,
            networkName: "Polygon",
            blockExplorer: "https://polygonscan.com/",
            ticker: "MATIC",
            tickerName: "MATIC",
            rpcUrl: "https://polygon-rpc.com",
          },
          whiteLabel: {
            walletTheme: {
              lang: `${window.navigator.language}`,
              logo: "https://i.ibb.co/L6vHB5d/company-logo-sample.png",
              name: "Company",
              buttonLogo: "https://i.ibb.co/wBmybLc/company-button-logo-sample.png",
              isActive: true,
              modalColor: "#fffff",
              bgColor: "#4B68AE",
              bgColorHover: "#214999",
              textColor: "#f3f3f3",
              textColorHover: "#214999",
              upbondLogin: {
                globalBgColor: "#ffffff",
                globalTextColor: "#4B68AE",
              },
              // consentConfiguration: {
              //   clientId: "576a597e28be9015b6e522040eeede2ad5ffd4edc1a2df55e04a6a8672e7865f",
              //   secretKey: "8c1817ee29b508e0e5271379a582cc66",
              //   scope: ["email", "name", "birthday"],
              // },
              // enableConsent: true,
            },
          },
          widgetConfig: {
            showAfterLoggedIn: true,
            showBeforeLoggedIn: false,
          },
        });
      }
      console.log("@init", this.upbond);
      if (!this.upbond.isLoggedIn) await this.upbond.login();
      const provider = this.upbond.provider;
      console.log("@login", provider);

      if (provider.on) {
        // console.log("@on");
        provider.on("connect", console.log("@this.upbond.isLoggedIn", this.upbond.isLoggedIn));
        provider.on("accountsChanged", this.onAccountsChanged);
        provider.on("chainChanged", async (res) => {
          console.log("@res", res);
          this.chain = res;
          console.log("@chain", this.upbond);
        });
        provider.on("disconnect", this.onDisconnect);
      }
      // Check if there is a user logged in
      const isAuthenticated = await this.isAuthorized();

      // Check if we have a chainId, in case of error just assign 0 for legacy

      console.log("@isAuthenticated", isAuthenticated);
      // if there is a user logged in, return the user
      if (isAuthenticated) {
        // const account = "0x597feEc90911564e2675D51EFC60aB956AC96c90";
        const signer = await this.getSigner();
        const account = await signer.getAddress();
        let chainId;
        try {
          chainId = await this.getChainId();
          // chainId = 1;
        } catch (e) {
          chainId = 0;
        }
        console.log("@account", account);
        return {
          account,
          chain: {
            id: chainId,
            unsupported: false,
          },
          provider,
        };
      }
    } catch (error) {
      console.log(error);
    }
  }

  async disconnect() {
    try {
      console.log("@disconnecting...");
      if (this.upbond) {
        await this.upbond.logout();
        await this.upbond.cleanUp();
        localStorage.clear();
        window.location.reload();
      }
    } catch (e) {
      console.log(e);
    }
  }

  async switchChain(chainId) {
    try {
      const chainId = this.upbond.provider.chainId;
      // console.log("@changedChainId from, to", this.upbond.provider.chainId, chainId);
      const selectedNetwork = this.chains.find((network) => network.id === chainId);
      if (!selectedNetwork) {
        console.log(`@Hold up! upbond does not support this network -> ${chainId}`);
      }
      if (!(await this.isAuthorized())) console.log("@please login first");
      await this.upbond.setProvider({
        host: selectedNetwork.id === 80001 ? "matic" : "mumbai",
        chainId: selectedNetwork.id === 80001 ? 137 : 80001,
        networkName: selectedNetwork.id === 80001 ? "Matic" : "Polygon",
      });
      console.log("@provider", this.upbond.provider);
      return this.upbond.provider.chainId;
    } catch (error) {
      console.log("@error", error);
      throw error;
    }
  }

  async getAccount() {
    return await this.signer.getAddress();
  }
  async getChainId() {
    if (this.upbond) return this.upbond.ethereum.chainId;
    throw new Error("Chain ID is not defined");
  }
  async getProvider() {
    return this.upbond.provider;
  }

  async getSigner() {
    this.signer = new ethers.providers.Web3Provider(this.upbond.provider);
    console.log("signer", this.signer);
    return this.signer.getSigner();
  }

  async isAuthorized() {
    return this.upbond && this.upbond.isLoggedIn;
  }

  async onAccountsChanged(accounts) {
    console.log("@onAccountsChanged detected", accounts);
  }

  async onChainChanged(chainId) {
    console.log("@onChainChanged detected", chainId);
  }

  async onDisconnect() {
    console.log("@onDisconnect detected");
    return this.disconnect;
  }
}
